"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertIconName = exports.WeatherTypes = void 0;
var WeatherTypes;
(function (WeatherTypes) {
    WeatherTypes["UV_INDEX"] = "UV_INDEX";
    WeatherTypes["HUMIDITY"] = "HUMIDITY";
    WeatherTypes["WIND_SPEED"] = "WIND_SPEED";
    WeatherTypes["CODE"] = "CODE";
    WeatherTypes["TEMPERATURE"] = "TEMPERATURE";
    WeatherTypes["PRECIPITATION"] = "PRECIPITATION";
})(WeatherTypes = exports.WeatherTypes || (exports.WeatherTypes = {}));
exports.convertIconName = {
    113: "sunny",
    116: "partlyCloudy",
    119: "cloudy",
    122: "overcast",
    143: "mist",
    176: "patchyRainPossible",
    179: "patchySnowPossible",
    182: "patchySleetPossible",
    185: "patchyFreezingDrizzlePossible",
    200: "thunderyOutbreaksPossible",
    227: "blowingSnow",
    230: "blizzard",
    248: "fog",
    260: "freezingFog",
    263: "patchyLightDrizzle",
    266: "lightDrizzle",
    281: "freezingDrizzle",
    284: "heavyFreezingDrizzle",
    293: "patchyLightRain",
    296: "lightRain",
    299: "moderateRainAtTimes",
    302: "moderateRain",
    305: "heavyRainAtTimes",
    308: "heavyRain",
    311: "lightFreezingRain",
    314: "heavyFreezingRain",
    317: "lightSleet",
    320: "heavySleet",
    323: "patchyLightSnow",
    326: "lightSnow",
    329: "patchySnow",
    332: "snow",
    335: "patchyHeavySnow",
    338: "heavySnow",
    350: "icePellets",
    353: "lightRainShower",
    356: "heavyRainShower",
    359: "torrentialRainShower",
    362: "lightSleetShower",
    365: "heavySleetShower",
    368: "lightSnowShower",
    371: "heavySnowShower",
    374: "lightShowersOfIcePellets",
    377: "heavyShowersOfIcePellets",
    386: "patchyLightRainInAreaWithThunder",
    389: "heavyRainInAreaWithThunder",
    392: "patchyLightSnowInAreaWithThunder",
    395: "heavySnowInAreaWithThunder",
};
